import * as React from 'react';
import { Control, UseFormGetValues, UseFormSetValue, } from 'react-hook-form';
import styled from 'styled-components';
import { Main } from 'styles/themeColors';
import { FontSize, FontWeight } from 'lib/styles';
import ServiceCountries from './ServiceCountries';
import ServiceProducts from './ServiceProducts';
import ServiceGeneralDetails from './ServiceGeneralDetails';
import { IFormData, VariantSKUForm } from 'data/Service';

export const SupportText = styled.span`
  font-size: 14px;
  color: ${Main.gray};
  opacity: 0.8;
`;

export const Heading = styled.h1`
  font-size: ${FontSize.large};
  font-weight: ${FontWeight.medium};
`;

interface Props {
  control: Control<IFormData>;
  errors: any;
  setValue?: UseFormSetValue<IFormData>;
  watch: any;
  getValues: UseFormGetValues<IFormData>;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  variantForm: VariantSKUForm;
  setVariantForm: (variant: VariantSKUForm) => void;
  onSearch: () => void;
  invalidSkus: string;
  setInvalidSkus: (invalidSkus: string) => void;
  setExistingSkus: (existingSkus: string) => void;
  isLoading?: boolean;
  setError?: any;
  clearErrors?: any;
  vendorId?: number;
  existingSkus: string;
  businessUnitId?: number;
}

const UpsertServiceForm: React.FC<Props> = ({ control,
  errors,
  setValue,
  getValues,
  watch,
  searchTerm,
  setSearchTerm,
  variantForm,
  setVariantForm,
  onSearch,
  invalidSkus,
  setInvalidSkus,
  isLoading = false,
  setError,
  clearErrors,
  vendorId,
  existingSkus,
  setExistingSkus,
  businessUnitId,
}: Props) => {

  return (
    <>
      {/* General Details */}
      <ServiceGeneralDetails
        control={control}
        errors={errors}
        watch={watch}
        setError={setError}
        clearErrors={clearErrors}
      />

      {/* Service Countries */}
      <ServiceCountries
        control={control}
        errors={errors}
        watch={watch}
        setError={setError}
        clearErrors={clearErrors}
        setValue={setValue}
        getValues={getValues}
      />


      {/** Service Products */}
      <ServiceProducts
        control={control}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        variantForm={variantForm}
        setVariantForm={setVariantForm}
        onSearch={onSearch}
        watch={watch}
        invalidSkus={invalidSkus}
        existingSkus={existingSkus}
        setInvalidSkus={setInvalidSkus}
        setExistingSkus={setExistingSkus}
        setValue={setValue}
        isLoading={isLoading}
        serviceId={getValues('id') ?? 0}
        vendorId={vendorId!}
        businessUnitId={businessUnitId!}
      />
    </>
  );
};

export default (UpsertServiceForm);
